import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { LoginService } from '../../../../../../../libs/utils/auth-shared/src/lib/services/login.service';
import { AddressComponent } from '../../../../../../../libs/utils/ng-shared-components/src/lib/address/address.component';
import { IdDocumentComponent } from '../../../../../../../libs/utils/ng-shared-components/src/lib/id-document/id-document.component';
import { CustomFormBuilder } from '../../../../../../../libs/utils/ng-shared-components/src/lib/validation/form-builder/custom-form-builder';
import { NaturalPersonDto, NaturalPersonDtoFormGroup } from '../../../../../../../libs/utils/ts-shared/src/lib/api/dtos/NaturalPersonDto';
import { PersonType } from '../../../../../../../libs/utils/ts-shared/src/lib/api/enums/PersonType';
import { Roles } from '../../../../api/enums/Roles';

@Component({
  standalone: false,
  selector: 'mf-natural-person',
  templateUrl: './natural-person.component.html',
  styleUrls: ['./natural-person.component.scss'],
})
export class NaturalPersonComponent {
  constructor(private _cfb: CustomFormBuilder, private _loginService: LoginService) {}

  @Input()
  naturalPersonDto: NaturalPersonDto;

  @Output()
  save = new EventEmitter<NaturalPersonDto>();

  @Output()
  close = new EventEmitter();

  @ViewChild('address', { static: false }) address: AddressComponent;
  @ViewChild('idDocument', { static: false }) idDocument: IdDocumentComponent;

  personType = PersonType;
  isSuperAdmin = this._loginService.userIsInRole([Roles[Roles.SuperAdmin]]);

  naturalPersonForm: FormGroup;

  ngOnInit(): void {
    this.naturalPersonForm = this._cfb.group<NaturalPersonDtoFormGroup>({
      firstName: ['', Validators.required, 'Nombre'],
      lastName: ['', Validators.required, 'Apellido'],
      idDocument: [null, null, 'Documento de identidad'],
      email: ['', [Validators.required, Validators.email], 'Email'],
      address: [null, null, 'Dirección'],
      isExemptFromOriginDeclaration: [false, Validators.required, 'No declara cuenta de origen'],
    });

    this.naturalPersonForm.patchValue(this.naturalPersonDto);
  }

  ngAfterViewInit(): void {
    const addressControl = this.naturalPersonForm.get('address')!;
    addressControl.setValidators(CustomFormBuilder.NestedFormValidator(this.address));
    addressControl.updateValueAndValidity();
    const idDocumentControl = this.naturalPersonForm.get('idDocument')!;
    idDocumentControl.setValidators(CustomFormBuilder.NestedFormValidator(this.idDocument));
    idDocumentControl.updateValueAndValidity();
  }
}
